<template>
    <div>
        <div class="multi-avatar-wrapper">
            <div
                v-if="first && idList.length > 0"
                class="agent-avatar first"
            >
                <Avatar
                    :size="50"
                    :src="first.gravatar"
                    :username="first.name"
                    v-tippy="{ content: first.name, placement: 'bottom' }"

                />
            </div>
            <div
                v-if="second && idList.length > 1"
                class="agent-avatar second"
            >
                <Avatar
                    :size="50"
                    :src="second.gravatar"
                    :username="second.name"
                    v-tippy="{ content: second.name, placement: 'bottom' }"
                />
            </div>
            <div
                v-if="third && idList.length > 2"
                class="agent-avatar third"
            >
                <Avatar
                    :size="50"
                    :src="third.gravatar"
                    :username="third.name"
                    v-tippy="{ content: third.name, placement: 'bottom' }"
                />
            </div>
            <div v-if="idList.length > 3"
                 class="number"
                 v-tippy="{ content: getExtraUsers(), placement: 'bottom' }">
                +{{ idList.length - 3 }}
            </div>
        </div>
    </div>
</template>

<script>
import Avatar from "vue-avatar";
import { mapState } from "vuex";

export default {
    components: { Avatar },
    name: "AgentList",
    props: {
        idList: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            first: null,
            second: null,
            third: null,
        };
    },
    computed: {
        ...mapState({
            users: (state) => state.user.users.data,
        }),
    },
    methods: {
        setAvatars() {
            if (this.users) {
                if (this.idList.length > 0) {
                    this.first = this.getUser(this.idList[0]);
                }
                if (this.idList.length > 1) {
                    this.second = this.getUser(this.idList[1]);
                }
                if (this.idList.length > 2) {
                    this.third = this.getUser(this.idList[2]);
                }
            }
        },
        getUser(userId) {
            return this.users.find((user) => user._id === userId) || {};
        },
        getExtraUsers() {
            return this.idList.slice(3).map(id => this.getUser(id).name).join('<br>');
        },
    },
    watch: {
        users: {
            handler() {
                this.$nextTick(() => {
                    this.setAvatars();
                });
            },
            immediate: true,
        },
        idList: {
            handler() {
                this.$nextTick(() => {
                    this.setAvatars();
                });
            },
            immediate: true,
        },
    },
};

</script>

<style scoped>

.multi-avatar-wrapper {
    display: flex;
    align-items: center;
    flex-direction: row;

    .agent-avatar {
        width: 50px;
        height: 50px;
        border-radius: 50%;
        background-color: #ccc;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-left: -25px;
        cursor: pointer;
        border: 1px solid #fff;
    }

    .agent-avatar.first {
        margin-left: 0;
    }

    .number {
        width: 50px;
        height: 50px;
        border-radius: 50%;
        background-color: #d7d9da;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 20px;
        font-weight: bold;
        margin-left: -25px;
        color: #FFFFFF;
        cursor: pointer;
    }
}
</style>
